import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/779c909d-21eb-42b8-b3dd-963e0113102c",
        "alt": "An image showing the CTA banner anatomy with a heading, a description and a button group."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Heading: The main title of the CTA banner. It should be short and concise.`}</li>
      <li parentName="ul">{`Description: Short text that extends the information provided by the heading.`}</li>
      <li parentName="ul">{`Button group: The call to actions available to users`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the CTA banner to draw attention around the main user actions. The CTA banner should be used sparingly and is typically placed at the bottom of the page to close the user journey,
make a short summary of the page, and to persist the main actions. The CTA banner can also be used between other sections on lengthy pages.`}</p>
    <p>{`The CTA banner can include primary and secondary actions. These actions are rendered as a `}<a parentName="p" {...{
        "href": "/components/ButtonGroup"
      }}>{`button group`}</a>{` and follow the same guidelines as the button group component.`}</p>
    <p>{`The actions used in a CTA banner are normally the same as the ones used on the `}<a parentName="p" {...{
        "href": "/components/Hero"
      }}>{`hero`}</a>{` component on the top of the page. This repetition provides consistency and helps the user to remember what the main actions are.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/952c6855-139b-42c1-a5df-ae3574c02f3c" alt="" />
    <Caption mdxType="Caption">
      Use the CTA banner on the bottom of the page to close the user journey and
      reinforce the main actions.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/389a4458-a558-4f8f-9656-d1aa51c82b3e" alt="" />
    <Caption mdxType="Caption">
      Don't use the CTA early on in the user journey, use a hero or a section
      intro component instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Align`}</h3>
    <p>{`The CTA banner elements can be aligned to the start or center of the page. By default, the CTA banner is aligned to the start of the page. Use the center alignment if context calls for it. E.g. Use the left alignement if there's a background image on the right side of the page or center align if the CTA banner is placed between two sections that are centered aligned to not break the visual flow.`}</p>
    <h3>{`Styles`}</h3>
    <h4>{`Background`}</h4>
    <p>{`The CTA banner uses a solid background color by default. This is the recommended style for most cases. However, the background can be removed to allow the content to blend with the background of the page.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/1a142793-0293-4fdd-8eca-a99c8325e340" alt="" />
    <Caption mdxType="Caption">
      Use the background by default to ensure that the content is legible.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/4d49b984-7baa-4f9e-a1f6-d4214640a4f7" alt="" />
    <Caption mdxType="Caption">
      Don't remove the background and keep the shadow, it will make the content
      hard to read.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Avoid using noisy or textured images that will make the content hard to read. Make sure that the combination of background and foreground guarantees compliance with WCAG contrast guidelines. Use an `}<a parentName="p" {...{
        "href": "https://webaim.org/resources/contrastchecker/"
      }}>{`online contrast checker`}</a>{` or a `}<a parentName="p" {...{
        "href": "/guides/accessibility/tools#contrast-plugin"
      }}>{`Figma plugin`}</a>{` to test your contrast.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/758ba20a-15c8-43b7-ae80-4be3d97f5d10" alt="" />
    <Caption mdxType="Caption">
      Use background images or colors that guarantee optimal contrast between
      the background and the foreground.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/85b6cce9-db22-4359-ba1e-db91a3761a6b" alt="" />
    <Caption mdxType="Caption">
      Don't use images that interfere with the legibility of the content.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h4>{`Shadow`}</h4>
    <p>{`The CTA banner has a shadow around the component to give it a sense of depth and separation from the background.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/22ccf3b3-7bed-4997-9b28-4d0d298386ac" alt="" />
    <Caption mdxType="Caption">
      Remove the shadow and the background to diminish the sense of depth and
      separation from the background or to allow the content to blend with the
      background of the page.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/a87c2851-41f4-41c5-810a-47b6270b1173" alt="" />
    <Caption mdxType="Caption">
      Don't use the shadow and the background together if you want the content
      to blend with the background and the sections that sorround the CTA
      banner.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h4>{`Border`}</h4>
    <p>{`The CTA banner can render a border around the component giving further separation between the foreground and background. This is especially useful when there is no shadow present on the background.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/a50c6341-6794-4e94-84bb-5351aad58151" alt="" />
    <Caption mdxType="Caption">
      Use the border only when there is no shadow present on the background.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/16d47d54-6d42-495b-975e-286cf3c73660" alt="" />
    <Caption mdxType="Caption">
      Don't use the border when there is a shadow present on the background. The
      shadow will provide enough separation between the foreground and
      background.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Hero"
        }}>{`Hero`}</a>{`: To display a large heading and a description with a button group.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/SectionIntro"
        }}>{`Section intro`}</a>{`: To provide a title, description and a link to a new section in the page.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      